import { useLayoutEffect, useRef } from "react";
export function useInterval(callback, delay) {
    const savedCallback = useRef(callback);
    useLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useLayoutEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const intervalId = window.setInterval(() => savedCallback.current(), delay);
        return () => {
            clearInterval(intervalId);
        };
    }, [delay]);
}
